export default "__VITE_ASSET__B0yD2ZnX__"